export const iconFontAwesomeTravelHotelShuttleSpace = (
	<i className="fa-solid fa-shuttle-space"></i>
);
